"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providers = void 0;
const channels_1 = require("./channels");
exports.providers = [...channels_1.emailProviders, ...channels_1.smsProviders, ...channels_1.chatProviders, ...channels_1.pushProviders];
